export const DAY = 'DAY';
export const WEEK = 'WEEK';
export const MONTH = 'MONTH';

// supported, but unused
export const QUARTER = 'QUARTER';
export const YEAR = 'YEAR';